// The languages a ride can be written in. Shared by the manual ride form
// (RideInformation.vue), the document import (ImportRideDocuments.vue) and the
// AI chat's ride-language card (utils/aiChatApply.js).
//
// CommonJS rather than `export`, because aiChatApply.js requires it and the
// unit tests run that file under plain node. The backend prompt lists the same
// values (ai_chat/prompt_builder.py :: RIDE_LANGUAGES) -- add a language to
// both, or the AI will propose one this card refuses.
//
// `label` is the language's own name; null means it is translated through t().
const RIDE_LANGUAGES = [
  { value: 'hebrew', label: null },
  { value: 'english', label: 'English' },
  { value: 'arabic', label: 'العربية' },
  { value: 'spanish', label: 'Español' },
  { value: 'french', label: 'Français' },
  { value: 'german', label: 'Deutsch' },
  { value: 'italian', label: 'Italiano' },
  { value: 'portuguese', label: 'Português' },
  { value: 'russian', label: 'Русский' },
  { value: 'chinese', label: '中文' },
  { value: 'japanese', label: '日本語' },
  { value: 'korean', label: '한국어' },
  { value: 'turkish', label: 'Türkçe' },
  { value: 'polish', label: 'Polski' },
  { value: 'dutch', label: 'Nederlands' },
  { value: 'greek', label: 'Ελληνικά' },
  { value: 'czech', label: 'Čeština' },
  { value: 'swedish', label: 'Svenska' },
  { value: 'norwegian', label: 'Norsk' },
  { value: 'danish', label: 'Dansk' },
  { value: 'finnish', label: 'Suomi' },
  { value: 'hungarian', label: 'Magyar' },
  { value: 'romanian', label: 'Română' },
  { value: 'bulgarian', label: 'Български' },
  { value: 'croatian', label: 'Hrvatski' },
  { value: 'serbian', label: 'Српски' },
  { value: 'slovak', label: 'Slovenčina' },
  { value: 'slovenian', label: 'Slovenščina' },
  { value: 'ukrainian', label: 'Українська' },
  { value: 'thai', label: 'ไทย' },
  { value: 'vietnamese', label: 'Tiếng Việt' },
  { value: 'indonesian', label: 'Bahasa Indonesia' },
  { value: 'malay', label: 'Bahasa Melayu' },
  { value: 'hindi', label: 'हिन्दी' },
];

const RIDE_LANGUAGE_CODES = RIDE_LANGUAGES.map(l => l.value);

function rideLanguageOptions(t) {
  return RIDE_LANGUAGES.map(l => ({ value: l.value, text: l.label || t(l.value) }));
}

// The name shown for a stored ride language. An unknown value is shown as
// itself rather than hidden, so a card never reads "replaces  with English".
function rideLanguageLabel(t, value) {
  const found = RIDE_LANGUAGES.find(l => l.value === value);
  if (!found) return value || '';
  return found.label || t(found.value);
}

module.exports = {
  RIDE_LANGUAGES,
  RIDE_LANGUAGE_CODES,
  rideLanguageOptions,
  rideLanguageLabel,
};
